import * as React from "react";
import classNames from "classnames";

type DivProps = JSX.IntrinsicElements["div"];
export interface VSpaceProps extends DivProps {
  /**
   * A space-delimited list of class names to pass along to a child element.
   */
  className?: string;

  /**
   * The vertical spacing between each child element
   */
  space: 0 | 4 | 8 | 12 | 16 | 24;
}
export const VSpace: React.FC<VSpaceProps> = ({
  className,
  space,
  ...divProps
}) => (
  <div
    className={classNames("v-space", `v-space--${space}`, className)}
    {...divProps}
  ></div>
);
;
import "/Users/jekri/.yarn/berry/cache/@sentry-bundler-plugin-core-npm-0.7.2-054e3436fd-10c0.zip/node_modules/@sentry/bundler-plugin-core/sentry-release-injection-file.js";